import Notify from "utils/notify";

import { adminFetchUsers } from "api";

import { ActionTypes } from "./type";

export const fetchUsers = (payload: any, callback: () => any) => async (dispatch: any) => {
  try {
    dispatch({ type: ActionTypes.REQUEST });

    const { data } = await adminFetchUsers(payload);

    dispatch({
      type: ActionTypes.SUCCESS,
      payload: data
    });

    if (callback)
      callback();
  } catch (error) {
    dispatch({
      type: ActionTypes.FAILURE,
      payload: error
    });

    Notify.error(error, true);
  }
};
